// Payment gateway abstraction.
//
// Every gateway implements the same interface so the checkout flow
// doesn't care which one is configured. Today: Bolt. Tomorrow: maybe
// Stripe, Adyen, PayPal, Braintree — they all plug in here without
// touching the checkout pages.
//
// Interface contract (all methods optional, sensibly handled if absent):
//
//   id            string                 stable identifier ("bolt", "stripe", ...)
//   label         string                 display name on the UI
//   features      { walletButtons, embeddedForm, hosted, savedCards }
//   loadSdk()     Promise<void>          inject script tags / wait for window.X
//   createIntent({ orderId, amount, currency, capture, customer, items, metadata })
//                 Promise<{ token, intentId, clientSecret? }>
//                                       Server-side via the BFF — adapter
//                                       module is the one that actually
//                                       calls the API; the gateway just
//                                       knows how to format the request.
//   mount({ container, token, intent, capture, on: { success, error, close } })
//                 Promise<void>          Renders the payment widget into
//                                       the DOM node.
//   unmount()     void                   Tear down the widget.
//
// "capture" is `true` for auth+capture (charge now) or `false` for
// auth-only (place a hold; capture happens after fulfilment, often via
// NetSuite). The mode is decided by the order policy and forwarded to
// the gateway so the same flow works either way.

import { boltGateway } from "./gateway.bolt";
import { stripeGateway } from "./gateway.stripe";

const REGISTRY = new Map([
  ["bolt", boltGateway],
  ["stripe", stripeGateway],
]);

export function registerGateway(g) {
  if (!g?.id) throw new Error("gateway.id is required");
  REGISTRY.set(g.id, g);
}

export function getGateway(id) {
  const g = REGISTRY.get(id);
  if (!g) throw new Error(`Unknown payment gateway: ${id}`);
  return g;
}

export function listGateways() {
  return Array.from(REGISTRY.values());
}
